import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

import { ROUTES } from "@/constants/routes";
import { usePermissionMatrix, Action, EntityName } from "@/lib/hooks/usePermissionMatrix";

interface PermissionRouteProps {
  children: ReactNode;
  entity: EntityName;
  action: Action;
  targetRole?: string;
  fallbackPath?: string;
}

/**
 * Route wrapper that checks permissions before rendering children
 * Redirects to fallback path if user doesn't have required permissions
 */
export const PermissionRoute = ({ 
  children, 
  entity, 
  action, 
  fallbackPath = ROUTES.campaigns 
}: PermissionRouteProps) => {
  const { can } = usePermissionMatrix();

  const hasPermission = can(entity, action);

  if (!hasPermission) {
    // Ensure absolute path for proper replacement
    const absolutePath = fallbackPath.startsWith('/') ? fallbackPath : `/${fallbackPath}`;
    return <Navigate to={absolutePath} replace />;
  }

  return <>{children}</>;
};
